import { Route, Switch } from 'react-router'

import { CreateDisplayGroupPage } from '../create-display-group/pages/CreateDisplayGroupPage'
import { DisplayGroupPage } from './pages/GetDisplayGroup'
import { LiveNoteArray } from './pages/Live'
import { NoteArrayMessageAppearanceHistoryPage } from './pages/MessageAppearanceHistory'
import { PairedArrays } from './pages/PairedArrays'
import React from 'react'

export const NoteArrayRouter = () => (
  <Switch>
    <Route exact path='/note-arrays/create' component={CreateDisplayGroupPage} />
    <Route exact path='/note-arrays/:id/live' component={LiveNoteArray} />
    <Route exact path='/note-arrays/:id/message-appearance-history' component={NoteArrayMessageAppearanceHistoryPage} />
    <Route exact path='/note-arrays/:id' component={DisplayGroupPage} />
    <Route exact path='/note-arrays' component={PairedArrays} />
  </Switch>
)
